"use client";

import styled from "styled-components";

export const BoxCountPage = styled.div`
  font-family: "Inter Normal";
  font-size: 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
